import { useContext, useEffect, useMemo, useState } from "react"
import _ from "underscore";
import { callautopopulate } from "../../../services/callautopop";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import { DateTime } from "luxon";
import { createAbbreviation } from "../../../utils/Helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const useCreatePorject = ({ showPopup }) => {

    const { showInfo, showSuccess, showError } = useContext(ToastContext);
    const [fieldValues, setFieldValues] = useState({ project_id: 0 });
    const [activeTab, setActiveTab] = useState({ index: 0 });
    const [options, setOptions] = useState({});
    const [isEdit, setIsEdit] = useState(false)
    const [subProjectList, setSubProjectList] = useState([])
    const tabs = [
        { index: 0, title: "Basic Info" },
        { index: 1, title: "Sub-Project Setup" },
        { index: 2, title: "Project Member Setup" },
        { index: 3, title: "Support Configuration" }
    ]

    const formJson = [
        {
            step: 1,
            label: "Project Details",
            fields: [
                {
                    label: "Product Name",
                    name: "product_code",
                    col: "4",
                    type: "select",
                    option: options?.productOption,
                    required: true,
                    disabled: fieldValues?.product_code || false
                },
                {
                    label: "Project Name",
                    name: "project_name",
                    col: "4",
                    type: isEdit ? "text" : "autocomplete",
                    option: options?.projectsOption,
                    required: true,
                    disabled: false,
                    textField: true
                },
                {
                    label: "Project Key",
                    name: "project_key",
                    col: "4",
                    type: "text",
                    required: true,
                    disabled: false
                },
                {
                    label: "Clients",
                    name: "client_ids",
                    col: "6",
                    type: "multiselect",
                    option: options?.clientOption,
                    required: true,
                    disabled: false
                },
                {
                    label: "Portfolio",
                    name: "project_portfolio_id",
                    col: "6",
                    type: "select",
                    option: options?.portfolioOption,
                    required: true,
                    disabled: false
                },
                {
                    label: "Status",
                    name: "project_status_id",
                    col: "6",
                    type: "select",
                    option: options?.projectStatus,
                    required: true,
                    disabled: false
                },
                {
                    label: "Priority",
                    name: "project_priority_id",
                    col: "6",
                    type: "select",
                    option: options?.priorityOption,
                    required: true,
                    disabled: false
                },
                {
                    label: "Start Date",
                    name: "project_start_date",
                    col: "6",
                    type: "date",
                    required: false,
                    disabled: false
                },
                {
                    label: "End Date",
                    name: "project_end_date",
                    col: "6",
                    type: "date",
                    required: false,
                    disabled: false
                },
            ]
        },
        {
            step: 2,
            label: "Sub Project",
            fields: [
                {
                    label: "Sub-Project Configuration",
                    name: "is_insights_product",
                    type: "switch"
                },
                {
                    label: "Project Name",
                    name: "sub_project_name",
                    col: "6",
                    type: "text",
                    required: true,
                    disabled: false,
                    depand: "is_insights_product"
                },
            ]
        }

    ]


    useEffect(() => {
        callautopopulate("projects", "client", "project_status", "product", "project_portfolio", "branch_master", "project_priority", "project_leads", "screen_schemes", "field_configuration_schemes").then(res => {
            setOptions({
                projectsOption: _.sortBy(res?.projects, "project_name").map(item => { return { ...item, value: item?.project_id, label: item?.project_name } }),
                clientOption: _.uniq(_.sortBy(res?.client, "client_name"), "client_id")?.map(item => { return { ...item, value: item?.client_id, label: item?.client_name } }),
                projectStatus: res?.project_status?.map(item => { return { ...item, value: item.project_status_id, label: item?.project_status_name } }),
                productOption: res?.product?.map(item => { return { ...item, value: item?.product_code, label: item?.product_name } }),
                portfolioOption: res?.project_portfolio?.map(item => { return { ...item, value: item?.project_portfolio_id, label: item?.project_portfolio_name } }),
                priorityOption: res?.project_priority?.map(item => { return { ...item, value: item?.project_priority_id, label: item?.project_priority_name } }),
                screenschemesOption: res?.screen_schemes?.map(item => { return { ...item, value: item?.screen_scheme_id, label: item?.screen_scheme_name } }),
                fieldconfigurationschemes: res?.field_configuration_schemes?.map(item => { return { ...item, value: item?.field_configuration_scheme_id, label: item?.field_configuration_scheme_name }})
            }) 
        });
    }, []);

    useEffect(() => {
        fieldValues?.project_id && getProjectSummary(fieldValues?.project_id)
    }, [fieldValues?.project_id])



    useState(() => {
        if (!_.isEmpty(showPopup?.data)) {
            setFieldValues((prev) => ({ ...prev, project_id: showPopup?.data?.project_id }))
        }
    }, [showPopup?.data]);

    const handleChange = (obj, e) => {
        if (obj.name === "project_name") {
            if (typeof (e.target.value) === "number") {
                const name = _.find(options?.projectsOption, { project_id: e.target.value })?.project_name
                setFieldValues((prev) => ({ ...prev, project_id: e.target.value, project_name: name, project_key: createAbbreviation(name), isChange: true }));
            } else if (typeof (e.target.value) === "string") {
                setFieldValues((prev) => ({ ...prev, project_id: fieldValues?.project_id, project_name: e.target.value, project_key: createAbbreviation(e.target.value), isChange: true }));
            }

        } else {
            setFieldValues((prev) => ({ ...prev, [obj?.name]: e.target.value, isChange: true }));
        }
    }


    const upsertProject = async () => {
        try {

            if (!fieldValues?.isChange) {
                showInfo("info", "No changes made");
                return;
            }
            if (!fieldValues.product_code) {
                showInfo("info", "Please select a product.");
                return;
            } else if (!fieldValues?.project_name) {
                showInfo("info", "Please select a project name.");
                return;
            }
            else if (!fieldValues?.project_key) {
                showInfo("info", "Please enter a project key.");
                return;
            }
            else if (_.isEmpty(fieldValues?.client_ids)) {
                showInfo("info", "Please select a client.");
                return;
            }
            else if (!fieldValues?.project_portfolio_id) {
                showInfo("info", "Please select a project portfolio.");
                return;
            }
            else if (!fieldValues?.project_status_id) {
                showInfo("info", "Please select a project status.");
                return;
            }
            else if (!fieldValues?.project_priority_id) {
                showInfo("info", "Please select a project priority.");
                return;
            }

            const payload = {
                "project_id": fieldValues?.project_id || 0,
                "product_code": fieldValues?.product_code,
                "project_name": fieldValues?.project_name,
                "project_key": fieldValues?.project_key,
                "project_portfolio_id": fieldValues?.project_portfolio_id || 0,
                "project_priority_id": fieldValues?.project_priority_id || 0,
                "project_status_id": fieldValues?.project_status_id || 0,
                "client_ids": fieldValues?.client_ids?.toString(),
                "project_start_date": fieldValues?.project_start_date ? DateTime.fromJSDate(new Date(fieldValues?.project_start_date)) : "",
                "project_end_date": fieldValues?.project_end_date ? DateTime.fromJSDate(new Date(fieldValues?.project_end_date)) : ""

            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTPROJECTINFO"), payload)
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message)
                sessionStorage.removeItem("projects")
                setFieldValues((prev) => ({ ...prev, isChange: false }))
            } else {
                showError("error", res?.body?.errorMessage)
            }
        } catch (error) {
            console.error(error)
        }
    }


    const getProjectSummary = async (id) => {
        try {
            const payload = {
                "project_id": id
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTINFO"), payload);
            if (!res?.body?.error_status) {
                const data = res?.body?.data?.project_info[0]
                setFieldValues((prev) => ({
                    ...prev,
                    project_id: data?.project_id,
                    project_name: data?.project_name,
                    client_ids: data?.client_ids?.split(',').map(Number).filter(id => id !== 0) || [],
                    product_code: data?.product_code,
                    project_start_date: data?.project_start_date,
                    project_end_date: data?.project_end_date,
                    project_portfolio_id: data?.project_portfolio_id,
                    project_priority_id: data?.project_priority_id,
                    project_status_id: data?.project_status_id,
                    project_key: data?.project_key,
                    product_project_id: data?.product_project_id,
                    is_atlassian: _.find(options?.productOption, { product_code: data?.product_code })?.product_type_key.includes("srkaycg_atlassian"),
                    is_insights_product: data?.is_insights_product ? true : false
                }))
            } else {
                setFieldValues({})
            }
        } catch (error) {
            console.error(error)
        }
    }


    const saveProject = async () => {
        try {

            if (!fieldValues?.sub_project_name) {
                showInfo("info", "Please select a sub project.");
                return;
            }
            if (fieldValues?.sub_project_name && _.pluck(subProjectList[0]?.children, "sub_project_name")?.includes(fieldValues?.sub_project_name)) {
                showInfo("Info", "The sub project already exists in this project. ");
                return;
            }
            const payload = {
                "project_id": fieldValues?.project_id,
                "sub_project_name": fieldValues?.sub_project_name
            }
            const res = await services.getInvokeRemote("POST", Urls("SAVESUBPROJECT"), payload);
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                setFieldValues((prev) => ({ ...prev, sub_project_name: '' }))
                getSubProject();
            } else {
                showError("error", res?.body?.errorMessage)
            }

        } catch (error) {
            console.error(error)
        }
    }

    const getSubProject = async () => {
        try {
            const payload = {
                "project_id": fieldValues?.project_id
            }
            const res = await services.getInvokeRemote("POST", Urls("GETSUBPROJECTLIST"), payload);
            if (!res?.body?.error_status) {
                setSubProjectList([{
                    id: "all",
                    title: "",
                    children: res?.body?.data?.sub_project_details
                }])
            } else {
                setSubProjectList([])
            }
        } catch (error) {
            console.error("error")
        }
    }

    useEffect(() => {
        activeTab.index === 1 && getSubProject()
        activeTab.index === 3 && getProjectConfiguration();
    }, [activeTab.index])


    const column = [
        {
            label: "Sub-Project Name",
            key: "sub_project_name",
            headerStyle: { background: "#f5f5f5" },
            style: { width: "90%", },
            render: (row) => <div>{row?.sub_project_name}</div>
        },
        {
            label: "Active",
            key: "",
            pinnded: "right",
            headerStyle: { background: "#f5f5f5" },
            style: { width: "10%", textAlign: "center" },
            render: (row) => {
                return <div>
                    <FontAwesomeIcon
                        icon="fa-solid fa-trash"
                        className="remove my-2"
                        onClick={() => deleteSubProject(row)} />
                </div>
            }
        }
    ]

    const deleteSubProject = async (row) => {
        try {
            const payload = {
                "project_id": fieldValues?.project_id,
                "context_id": row?.context_id
            }
            const res = await services.getInvokeRemote("POST", Urls("REMOVESUBPROJECT"), payload);
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message)
                getSubProject();
            } else {
                showError("error", res?.body?.errorMessage)
            }
        } catch (error) {
            console.error(error)
        }
    }

    const upsertProjectConfiguration = async (key, value) => {
        try {
            const payload = {
                "project_id": fieldValues?.project_id,
                "is_auto_build_allow": key === "is_auto_build_allow" ? value : fieldValues?.is_auto_build_allow || false,
                "timesheet_manager_code": key === "timesheet_manager_code" ? value : fieldValues?.timesheet_manager_code,
                "is_import_allow": key === "is_import_allow" ? value : fieldValues?.is_import_allow || false,
                "project_prefix": key === "project_prefix" ? value : fieldValues?.project_prefix || "",
               "screen_scheme_id": key === "screen_scheme_id" ? value : fieldValues?.screen_scheme_id || 0,
                "field_configuration_scheme_id": key === "field_configuration_scheme_id" ? value : fieldValues?.field_configuration_scheme_id || 0,
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTPROJECTCONFIGURATION"), payload);
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message)
                getProjectConfiguration()
            } else {
                showError("error", res?.body?.message)
            }
        } catch (error) {
            console.error(error)
        }

    }

    const getProjectConfiguration = async () => {
        try {
            const payload = {
                "project_id": fieldValues?.project_id,
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTCONFIGURATION"), payload);
            if (!res?.body?.error_status) {
                const data = res?.body?.data?.project_configuration_detail[0]
                const leadData = res?.body?.data?.project_lead_details
                setOptions((prev) => ({ ...prev, projectLead: leadData }))
                setFieldValues((prev) => ({
                    ...prev,
                    ...data,
                    timesheet_manager_code: data?.timesheet_manager_code || 0
                }))
            }
        } catch (error) {

        }
    }


    return useMemo(() => ({
        formJson, handleChange, tabs, fieldValues, activeTab, setActiveTab, upsertProject, setFieldValues, saveProject, subProjectList, column, upsertProjectConfiguration, options, isEdit, setIsEdit
    }), [formJson, handleChange, tabs, fieldValues, activeTab, setActiveTab, upsertProject, setFieldValues, saveProject, subProjectList, column, upsertProjectConfiguration, options, isEdit, setIsEdit])
}